// Every host is served the same bundle (build.sh builds without an environment flag), so the
// deployment a Datadog RUM event comes from is read from the hostname at runtime. Only production
// is tracked. Other hosts (the secure3 test environment, dev servers, other white-label portals)
// are not, unless RUM is switched on for the browser with `localStorage.setItem('flexigo.rum', 'on')`;
// a dev server can proxy to production data, so it must never report by default.
// `localStorage.setItem('flexigo.rum', 'off')` switches RUM off for the browser on every host,
// production included (support, debugging). Both take effect on the next page load.
const DEPLOYMENTS = {
  'secure.flexigo.com': { env: 'prod', deployment: 'tr' },
  'portal.flexigo.com': { env: 'prod', deployment: 'us' },
};

export const RUM_DEV_FLAG = 'flexigo.rum';

function readDevFlag() {
  try {
    return localStorage.getItem(RUM_DEV_FLAG);
  } catch (error) {
    return null;
  }
}

/**
 * @param {string} [hostname]
 * @param {string|null} [devFlag] this browser's `flexigo.rum` value: 'on', 'off' or none
 * @returns {{ env: string, deployment: string } | null} null when RUM must stay off
 */
export function getDeployment(hostname = window.location.hostname, devFlag = readDevFlag()) {
  if (devFlag === 'off') return null;
  const known = DEPLOYMENTS[hostname.toLowerCase()];
  if (known) return known;
  return devFlag === 'on' ? { env: 'local', deployment: 'local' } : null;
}
